import React, {memo} from "react";
import FormatNumber from "../../../../FormatNumber";

function Quantity(props) {
    const { record } = props;

    return (
        <div className="BaseTable__row-cell-text">
            <FormatNumber amount={record.quantity} dp2={4} />
        </div>
    );
}

export default memo(Quantity);
